// Module
var code = "<template> <require from=\"app/core/components/tasks/task\"></require> <div class=\"row\"> <div class=\"col s12 m10 offset-m1\"> <task task-binding.bind=\"taskBinding\" label-key=\"cm:carePlanIntervention.$\" mcg-copyright.bind=\"mcgCopyright\" task-display.bind=\"taskDisplay\"></task> </div> </div> </template> ";
// Exports
module.exports = code;